import type { NotificationDto } from '@/core/data/notification/notification.interface';
import { NotificationEndpoint } from '@/core/network/api/constants/api.url.constant';
import { baseNotificationFields } from '@/core/network/api/constants/notification.api_fields';
import { HttpClient } from '@/core/network/http/httpClient';
import type { GamResponse } from '@/core/network/http/httpClient.interface';
import type { AxiosResponse } from 'axios';

export interface NotificationApiOptions {
  unread?: boolean;
  afterCursor?: string | null;
}
export class NotificationApi {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  async getNotifications(options?: NotificationApiOptions): Promise<AxiosResponse<GamResponse<NotificationDto[]>>> {
    return this.httpClient.get<NotificationDto[]>(NotificationEndpoint.GET_NOTIFICATIONS, {
      config: {
        params: {
          unread: options?.unread,
          afterCursor: options?.afterCursor,
          fields: baseNotificationFields.join(','),
        },
      },
    });
  }

  async markAsRead(id: string): Promise<AxiosResponse<GamResponse<{ unreadCount: number }>>> {
    return this.httpClient.put(NotificationEndpoint.READ_NOTIFICATION, {
      urlParams: { id },
      data: { read: true },
    });
  }

  async markAllAsRead(): Promise<AxiosResponse<GamResponse<{ unreadCount: number }>>> {
    return this.httpClient.put(NotificationEndpoint.READ_NOTIFICATIONS, {
      data: { read: true },
    });
  }

  async deleteAll(): Promise<AxiosResponse<GamResponse<{ deletedCount: number }>>> {
    return this.httpClient.delete(NotificationEndpoint.GET_NOTIFICATIONS);
  }
}
